/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AdditionalCostsDto } from '../../models/additional-costs-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface SaveNewAdditionalCost$Params {
  body: AdditionalCostsDto;
}

export function saveNewAdditionalCost(
  http: HttpClient,
  rootUrl: string,
  params: SaveNewAdditionalCost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AdditionalCostsDto>> {
  const rb = new RequestBuilder(rootUrl, saveNewAdditionalCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdditionalCostsDto>;
    }),
  );
}

saveNewAdditionalCost.PATH = '/service/v1/afterSales/additionalCosts';
